var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.shippingTypes),function(shippingType,key){return _c('input',{key:key,attrs:{"name":"shippingType","type":"hidden"},domProps:{"value":key}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }